import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import QuickNotesReports from './QuickNotesReports';

// Create a client compatible with @apollo/client
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: {
    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
  }
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
  },
});

/**
 * Container component for Quick Notes Reports that provides Apollo GraphQL context.
 * This follows the established pattern in the FindBob application where containers
 * handle data providers and the main component handles business logic.
 */
const QuickNotesReportsContainer = (props) => {
  return (
    <ApolloProvider client={client}>
      <QuickNotesReports {...props} />
    </ApolloProvider>
  );
};

QuickNotesReportsContainer.propTypes = {
  current_user: PropTypes.string,
  activity_types: PropTypes.string,
  quick_note_categories: PropTypes.string,
};

export default QuickNotesReportsContainer;
